// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","6637":"faf842696a022540","7879":"99ab4f38cdecdcde","8199":"a278752707f705af","9700":"d5f8a49525530ebf"}[chunkId] + ".css";
};